export default __webpack_public_path__ + "static/media/careersHeader.34668433.png";